import { resolveUrl } from "../../utils/url/urlResolver";

export async function apiMarkAsReadOrUnread(uid: string) {
  const url = resolveUrl(`/notifications/markAsReadOrUnread?uid=${uid}`);

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });

  return await response.json();
}
